class FiltersForm extends HTMLElement {
  filterContainer: Element | null;
  constructor() {
    super();

    this.filterContainer = document.querySelector(".filters-container");

    this.isSafari = this.isSafari.bind(this);
    if (this.isSafari()) document.documentElement.classList.add("is-safari");

    const facetWrapper = this.querySelector<HTMLElement>("#FiltersWrapper");
    if (facetWrapper)
      facetWrapper.addEventListener("keyup", this.onKeyUpEscape.bind(this));

    if (this.filterContainer) {
      const filterButtons = document.querySelectorAll("[data-toggle-filter]");
      if (filterButtons) {
        filterButtons.forEach((button) => {
          button.addEventListener("click", () => {
            if (this.filterContainer?.classList.contains("--open")) {
              this.closeFilters();
              return;
            }

            this.openFilters(button as HTMLElement);
          });
        });

        this.filterContainer.addEventListener("click", (event) => {
          if (event.target == this.filterContainer) {
            this.closeFilters();
          }
        });
      }
    }
  }

  isSafari() {
    const ua = navigator.userAgent;
    return (
      /Safari/i.test(ua) &&
      !/Chrome|Chromium|CriOS|EdgiOS|Edg|OPR|Firefox|FxiOS|Android/i.test(ua)
    );
  }

  forceSafariRepaint() {
    if (!this.isSafari()) return;

    const targets = [
      document.querySelector("#MainContent"),
      document.querySelector("main#MainContent"),
      document.querySelector("#ProductGridContainer"),
      document.querySelector("#product-grid"),
      document.querySelector(".product-grid-container"),
      document.querySelector(".shopify-pc__banner__dialog"),
    ].filter(Boolean);

    if (!targets.length) return;

    targets.forEach((el) => {
      const htmlEl = el as HTMLElement;
      (
        htmlEl.style as CSSStyleDeclaration & {
          webkitTransform: string;
        }
      ).webkitTransform = "translateZ(0)";
      htmlEl.style.transform = "translateZ(0)";
    });

    requestAnimationFrame(() => {
      targets.forEach((el) => {
        const htmlEl = el as HTMLElement;
        (
          htmlEl.style as CSSStyleDeclaration & {
            webkitTransform: string;
          }
        ).webkitTransform = "";
        htmlEl.style.transform = "";
      });
    });
  }

  openFilters(button: HTMLElement) {
    this.filterContainer?.classList.add("--open");
    document.body.classList.add("--no-scroll");

    if (this.isSafari()) requestAnimationFrame(() => this.forceSafariRepaint());

    if (button?.dataset?.filterTarget) {
      const target = document.getElementById(button.dataset.filterTarget);
      if (target) {
        target.setAttribute("open", "true");
        const summary = target.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", "true");
      }
    }
  }

  closeFilters() {
    if (!this.filterContainer) return;
    this.filterContainer.classList.remove("--open");
    document.body.classList.remove("--no-scroll");

    this.filterContainer
      .querySelectorAll("details[open]")
      .forEach((details) => {
        details.removeAttribute("open");
        const summary = details.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", "false");
      });

    if (this.isSafari()) requestAnimationFrame(() => this.forceSafariRepaint());
  }

  onKeyUpEscape(event: KeyboardEvent) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = (event.target as Element)?.closest(
      "details[open]",
    );
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement?.setAttribute("aria-expanded", "false");
    summaryElement?.focus();
  }
}

customElements.define("filters-form", FiltersForm);
